module.exports = __webpack_public_path__ + "static/img/broadcast-alive.c4b63e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/broadcast-alive.png
// module id = w8cU
// module chunks = 86